export default {
  DpAttemptCard: {
    ariaLabel: '{{curriculum}}, assessment {{name}}',
    em: 'Eureka Math',
    ww: 'Wit And Wisdom',
    phd: 'PhD',
    geo: 'Geodes'
  }
};